import { render, staticRenderFns } from "./Carousel.Company.vue?vue&type=template&id=87808ed4&scoped=true&"
import script from "./Carousel.Company.vue?vue&type=script&lang=js&"
export * from "./Carousel.Company.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.Company.vue?vue&type=style&index=0&id=87808ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87808ed4",
  null
  
)

export default component.exports